import { call, put, select } from 'redux-saga/effects';
import { sendToSE as sentToSEPromise } from '@bitComponents/adabyron/se';
import { WEB_SERVICES } from './webServices';

const contextStore = state => state.context.data;

export function* sendToSE(params) {
  const {
    contactPhone,
    contactEmail,
    cqId,
    message,
    subject,
    reduxUpdate,
    normalizeHttpErrors,
  } = params;

  try {
    const { successUpdate } = reduxUpdate;
    const context = yield select(contextStore);
    const args = {
      contactPhone,
      contactEmail,
      cqId,
      message,
      subject,
    };
    const response = yield call(sentToSEPromise, args, context);
    yield put(successUpdate(response));
    return response;
  } catch (error) {
    const { errorUpdate } = reduxUpdate;
    const errorNormalized = yield call(normalizeHttpErrors,
      WEB_SERVICES.SHIPPING_TO_SE,
      error);
    if (errorUpdate) {
      yield put(errorUpdate(errorNormalized));
    }
    throw error;
  }
}
